import { ModuleWithProviders, NgModule } from '@angular/core';
import { CmsModule } from './cms';
import { ConfigInitializerModule, ConfigModule, ConfigValidatorModule } from './config';
import { FeaturesConfigModule } from './features-config';
import { GlobalMessageModule } from './global-message';
import { I18nModule } from './i18n';
import { LazyLoadingModule } from './lazy-loading/lazy-loading.module';
import { BaseOccModule } from './occ';
import { ProcessModule } from './process';
import { SiteContextModule } from './site-context';
import { StateModule } from './state';

@NgModule({
  imports: [
    StateModule.forRoot(),
    ConfigModule.forRoot(),
    ConfigInitializerModule.forRoot(),
    ConfigValidatorModule.forRoot(),
    I18nModule.forRoot(),
    CmsModule.forRoot(),
    GlobalMessageModule.forRoot(),
    ProcessModule.forRoot(),
    FeaturesConfigModule.forRoot(),
    SiteContextModule.forRoot(), // should be imported after RouterModule.forRoot, because it overwrites UrlSerializer
    BaseOccModule.forRoot(),
    LazyLoadingModule.forRoot(),
  ],
})
export class SpartacusCoreModule {
  static forRoot(): ModuleWithProviders<SpartacusCoreModule> {
    return {
      ngModule: SpartacusCoreModule,
    };
  }
}
